var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('go-for-good',{attrs:{"catalog-text":_vm.catalogText,"commission-percentage":_vm.commissionPercentage,"raised-amount":_vm.raisedAmount,"institutions-number":_vm.institutionsNumber,"asset":_vm.asset,"institutions":_vm.institutions}})}
var staticRenderFns = []

export { render, staticRenderFns }